// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","3930":"164f4fb6","4316":"ad2866b8","5033":"2f0b94e8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","1536":"06f7a2ea2d36a524","3930":"88ed99818f9e53d2","4316":"da7517a88118b074","5033":"38cf38fdbc42c7b4","6457":"122037aed297f547","9839":"97db545449e006dc"}[chunkId] + ".js";
};